/*
  SIGNATURE COUNTDOWN OFFSET

  Keeps the sticky header under the Essential Countdown bar instead of behind it. The app embed injects the bar as the
  first child of <body> with `position: sticky; top: 0; z-index: 11`, the same top as the sticky header (z-index 10),
  so on scroll both stick at 0 and the bar covers the header. This script sets --signature-countdown-bar-height on
  <html> from the bar actually on the page; signature-countdown-offset.css adds it to the header's sticky top and to
  the theme's --sticky-area-height, so everything that sticks under the header moves down with it.

  The bar shows up late (app script), is removed from the DOM by its close button or when the campaign ends, and
  changes height across breakpoints, so all three are watched. A bar placed at the bottom of the page counts as 0.
*/
(() => {
  const BAR_SELECTOR = '.essential_countdown_annoucement_bar_wrapper.top_page';
  const VARIABLE = '--signature-countdown-bar-height';

  let bar = null;

  const update = () => {
    const height = bar?.isConnected && getComputedStyle(bar).position === 'sticky' ? bar.getBoundingClientRect().height : 0;
    document.documentElement.style.setProperty(VARIABLE, `${height}px`);
  };

  const resizeObserver = new ResizeObserver(update);

  const track = () => {
    const current = document.querySelector(BAR_SELECTOR);

    if (current === bar) {
      return;
    }

    if (bar) {
      resizeObserver.unobserve(bar);
    }

    bar = current;

    if (bar) {
      resizeObserver.observe(bar);
    }

    update();
  };

  track();

  // The app inserts and removes the bar as a direct child of <body>; childList alone skips the timer's own ticks.
  new MutationObserver(track).observe(document.body, { childList: true });
})();
